import type { ReactNode } from 'react'
import { faArrowsMinimize, faXmark } from '@fortawesome/pro-regular-svg-icons'
import { Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { Leaf } from '@/features/adviser-chat/components/Leaf'
import { HeaderButton } from '@/features/adviser-chat/components/HeaderButton'
import { HAVEN_TITLE } from '@/features/adviser-chat/lib/constants'
import '@/features/adviser-chat/adviser-chat.scss'

interface HavenFullScreenProps {
  rail: ReactNode
  children: ReactNode
  onExitFullScreen: () => void
  onClose: () => void
}

export const HavenFullScreen = ({
  rail,
  children,
  onExitFullScreen,
  onClose,
}: HavenFullScreenProps) => (
  <div
    className="adviser-panel shadow-none! flex flex-col flex-1 min-w-0 h-full overflow-hidden rounded-tl-[40px] rounded-bl-[40px] border-l border-neutral-100"
    data-testid="haven-full-screen"
  >
    <div className="flex items-center shrink-0 h-12 pl-8 pr-3">
      <div className="flex items-center gap-2 w-[344px] shrink-0">
        <Leaf size={16} />
        <Text variant={TypographyStyles.H3}>{HAVEN_TITLE}</Text>
      </div>
      <div className="flex flex-1 items-center justify-end">
        <HeaderButton
          icon={faArrowsMinimize}
          label="Exit full screen"
          onClick={onExitFullScreen}
        />
        <HeaderButton icon={faXmark} label="Close Haven" onClick={onClose} />
      </div>
    </div>
    <div className="flex flex-1 min-h-0">
      <aside className="w-[376px] shrink-0 flex flex-col min-h-0 pl-6 pr-6">
        {rail}
      </aside>
      <div className="adviser-panel-card [view-transition-name:haven-card] relative flex flex-col flex-1 min-w-0 min-h-0 mr-3 rounded-t-[24px] overflow-hidden bg-neutral-0">
        {children}
      </div>
    </div>
  </div>
)
